define('views/wellness/multipurse/purse_item',[
	'backbone',
	'views/_base/baseview',
	'text!views/wellness/multipurse/purse_item.html',
], function(Backbone, BaseView, Template) {
	'use strict';

	return BaseView.extend({
		tagName : 'li',
		isRender: true,
		needsAuth: true,
		template: _.template(Template),
		events  : {
			'click'  : 'toggleItem'
		},
		initialize: function(options){
			options = options || {};
			
			this.model = options.data;
			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function(){

			var text = this.model.text,
				needle = this.model.link_text,
				link = this.model.link_url;

			
			var replaced_link = text.replace(needle, '<a href="' + link + '" target="_blank">' + needle + '</a>')

			this.$el.html(this.template({ data: this.model, replaced_link: replaced_link }));

			return this;
			
		},

		toggleItem:function(e) {

			var target = this.$('.multipurse-description'),
				arrow_icon = this.$('.js-toggle-reward');

			

			if (target.hasClass('closed')) {
				target.removeClass('closed');
				arrow_icon.addClass('open');
			} else {
				target.addClass('closed');
				arrow_icon.removeClass('open');
			}

		},

		loadData: function(){ },

	
		close: function(){}
	});
});

